import { ca } from '@cian/analytics';
import { IRouteData, TRoutingMode } from '@cian/frontend-newbuilding-map-component';

const WAY_MODE_MAP = new Map<TRoutingMode, string>([
  ['pedestrian', 'foot'],
  ['masstransit', 'public'],
  ['auto', 'car'],
]);

interface ISearchResult {
  mode: TRoutingMode;
  routes: IRouteData[];
  wayPoints: {
    address: string;
    coordinates: [number, number];
    index: number;
  }[];
}

interface ITrackBuildRouteSuccessParams {
  isObjectPoint: boolean;
  objectType?: string;
  searchResult: ISearchResult;
  isFutureObject: boolean;
  hasFutureInfrastructure: boolean;
}

export const mapRequestParams = (searchResult: ISearchResult) => {
  const pointTo = searchResult.wayPoints.find(point => point.index === 1);

  return {
    address: pointTo ? pointTo.address : undefined,
    coordinates: pointTo ? pointTo.coordinates : undefined,
    way_type: WAY_MODE_MAP.get(searchResult.mode),
  };
};

export function trackBuildRouteSuccess({
  objectType,
  searchResult,
  isObjectPoint,
  isFutureObject,
  hasFutureInfrastructure,
}: ITrackBuildRouteSuccessParams) {
  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: 'build_route',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Normal',
        object_type: objectType,
        search_request: mapRequestParams(searchResult),
        search_results: searchResult.routes,
        route_cnt: searchResult.routes.length,
        type_in: !isObjectPoint,
        is_future_object: isFutureObject,
        block_type: hasFutureInfrastructure ? 'future' : 'standard',
      },
    },
    useLastProducts: true,
  });
}
